module.exports = __webpack_public_path__ + "img/import-modal-creatingImport.f0c60387.svg";